import { cn } from '@/lib/cn';

export interface HomeFilterItemProps {
  label: string;
  /** Figma-exported SVG asset URL. */
  icon: string;
  selected?: boolean;
  onClick?: () => void;
  className?: string;
}

/**
 * Figma HomeFilterItem — icon + label chip.
 * Selected: action-primary-hover fill + on-action text.
 * Default: elevated fill + secondary text.
 */
export function HomeFilterItem({
  label,
  icon,
  selected = false,
  onClick,
  className,
}: HomeFilterItemProps) {
  return (
    <button
      type="button"
      role="listitem"
      onClick={onClick}
      aria-pressed={selected}
      className={cn(
        // Figma rail is 32px; avoid py-2 + 18px icon (34px) overflowing h-8.
        'flex h-8 shrink-0 items-center justify-center gap-2 rounded-md px-3',
        selected
          ? 'bg-action-primary-hover text-text-on-action'
          : 'bg-bg-elevated text-text-secondary',
        className,
      )}
    >
      <span className="relative size-[18px] shrink-0 overflow-clip">
        <img
          src={icon}
          alt=""
          draggable={false}
          width={18}
          height={18}
          className="absolute inset-0 size-full max-w-none object-contain"
        />
      </span>
      <span className="text-label-s whitespace-nowrap">{label}</span>
    </button>
  );
}
